var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Input } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
var AddProbeSetFamilyModal = /** @class */ (function (_super) {
    __extends(AddProbeSetFamilyModal, _super);
    function AddProbeSetFamilyModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onNameChange = function (event, data) {
            var value = data.value;
            _this.setState({
                name: value,
            });
        };
        _this.onDescriptionChange = function (event, data) {
            var value = data.value;
            _this.setState({
                description: value
            });
        };
        _this.onGeneSymbolChange = function (event, data) {
            var value = data.value;
            _this.setState({
                geneType: value
            });
        };
        _this.submitPsf = function () {
            _this.props.postRequest("/admin/catalog/rna/organisms/id/" + encodeURIComponent(_this.props.orgId.toString()) + "/probe-set-families", {
                name: _this.state.name,
                description: _this.state.description,
                geneType: _this.state.geneType
            });
        };
        _this.state = {
            name: '',
            description: '',
            geneType: ''
        };
        return _this;
    }
    AddProbeSetFamilyModal.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(FieldWithErrorDisplay, { errorPath: '/name', errors: this.props.state.errors, required: true, labelContent: 'Probe set family name' },
                React.createElement(Input, { placeholder: 'Target', onChange: this.onNameChange, value: this.state.name })),
            React.createElement(FieldWithErrorDisplay, { errorPath: '/description', errors: this.props.state.errors, labelContent: 'Description', required: true },
                React.createElement(Input, { placeholder: 'description', onChange: this.onDescriptionChange, value: this.state.description })),
            React.createElement(FieldWithErrorDisplay, { errorPath: '/gene-type', errors: this.props.state.errors, labelContent: 'Gene type' },
                React.createElement(Input, { placeholder: 'Gene Type', onChange: this.onGeneSymbolChange, value: this.state.geneType })),
            React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: 'plus', label: 'Add probe set family', labelPosition: 'left', onClick: this.submitPsf, positive: true }));
    };
    return AddProbeSetFamilyModal;
}(React.PureComponent));
export default AddProbeSetFamilyModal;
//# sourceMappingURL=AddProbeSetFamilyModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AddProbeSetFamilyModal.js
// module id = 1455
// module chunks = 0